type MenuIcon = {
    active?: boolean;
    color: string;
    activeColor: string;
}

export function HomeIcon({ active = false, color, activeColor }: MenuIcon){
    return (

        <svg width="32" height="26" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M50.98 25.945C50.98 27.7053 49.68 29.0756 48.2 29.0756H45.42L45.48 44.7187C45.48 44.9788 45.46 45.2488 45.44 45.5089V47.0892C45.44 49.2496 43.89 51 41.97 51H40.58C40.48 51 40.39 51 40.29 51C40.17 51 40.05 51 39.93 51H37.11H35.03C33.11 51 31.56 49.2496 31.56 47.0892V38.4975C31.56 36.7672 30.32 35.3769 28.78 35.3769H23.22C21.68 35.3769 20.44 36.7772 20.44 38.4975V47.0892C20.44 49.2496 18.89 51 16.97 51H12.12C11.99 51 11.86 51 11.73 50.98C11.63 50.98 11.52 51 11.42 51H10.03C8.11 51 6.56 49.2496 6.56 47.0892V36.147C6.56 36.057 6.56 35.957 6.56 35.877V29.0656H3.78C2.22 29.0656 1 27.6953 1 25.935C1 25.0548 1.26001 24.2747 1.87001 23.5945L24.12 1.78015C24.73 1.10002 25.42 1 26.03 1C26.64 1 27.33 1.20004 27.85 1.68014L50.03 23.6045C50.72 24.2847 51.07 25.0648 50.99 25.945H50.98Z"  stroke = { active? activeColor: color } strokeMiterlimit="10" strokeLinejoin="round"/>
        </svg>
        
    )
}